export default __webpack_public_path__ + "static/media/collegetown-coverpic.8150dc3a.svg";